module.exports = __webpack_public_path__ + "img/solutions-sub-bg.2e0e45e0.png";